import ShoppingBagIconPath from "@ingka/ssr-icon/paths/shopping-bag";

export default ShoppingBagIconPath;
